<template>
  <div class="h-full overflow-hidden grid grid-rows-[auto_1fr] bg-base-200">
    <!-- 导航栏 -->
    <ThreadsNav :show-back="true" :go-back="goBack">
      <template #center> 我的任务 </template>
      <template #right>
        <div class="flex items-center gap-1 text-xs">
          常驻屏幕
          <VanSwitch
            size="small"
            v-model="taskScreen"
            @change="onTaskScreenChange"
          />
        </div>
      </template>
    </ThreadsNav>

    <!-- 统计概览 -->
    <div class="overflow-hidden h-full grid grid-rows-[auto_1fr]">
      <!-- <div class="px-4 py-2">
        <div class="stats shadow bg-base-100 w-full">
          <div class="stat">
            <div class="stat-title text-xs">总任务</div>
            <div class="stat-value text-lg">
              {{ taskStore.taskStats.total }}
            </div>
          </div>
          <div class="stat">
            <div class="stat-title text-xs">进行中</div>
            <div class="stat-value text-lg text-primary">
              {{ taskStore.taskStats.inProgress }}
            </div>
          </div>
          <div class="stat">
            <div class="stat-title text-xs">已完成</div>
            <div class="stat-value text-lg text-success">
              {{ taskStore.taskStats.completed }}
            </div>
          </div>
        </div>
      </div> -->

      <!-- 筛选标签 -->
      <div class="mb-2">
        <van-tabs
          v-model:active="taskStore.activeFilter.status"
          @change="onTabChange"
          class="bg-base-100"
        >
          <van-tab
            v-for="tab in filterTabs"
            :key="tab.value"
            :name="tab.value"
            :title="tab.label"
          />
        </van-tabs>
      </div>

      <!-- 任务类型筛选 -->
      <!-- <div class="px-4 mb-4">
        <div class="flex flex-wrap gap-2">
          <button
            v-for="type in taskTypes"
            :key="type.value"
            :class="[
              'btn btn-sm',
              selectedType === type.value
                ? 'btn-primary'
                : 'btn-outline btn-primary',
            ]"
            @click="onTypeChange(type.value as UserTaskType | 'all')"
          >
            {{ type.label }}
          </button>
        </div>
      </div> -->

      <!-- 任务列表 -->
      <div class="pb-4 overflow-hidden h-full">
        <ThreadList
          ref="listRef"
          :on-pull-load="onPullRefresh"
          :on-scroll-load="onScrollLoad"
        >
          <!-- 任务列表 -->
          <TaskCard
            class="mx-4"
            v-for="task in taskStore.filteredTasks"
            :key="task.id"
            :task="task"
            @click="openTaskDetail(task.id!)"
            @claim="claimReward(task.id!)"
          />
        </ThreadList>
      </div>
    </div>

    <!-- 任务详情弹窗 -->
    <TaskDetailModal
      v-model:show="taskStore.showTaskDetailModal"
      :task="taskStore.activeTask"
      @claim="claimReward"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useUserTask } from "@/stores/userTask";
import TaskCard from "@/components/User/TaskCard.vue";
import TaskDetailModal from "@/components/User/TaskDetailModal.vue";
import ThreadList, {
  ThreadListInstance,
} from "@/components/mobile/ThreadList.vue";
import { showFailToast } from "vant";
import { UserTaskStatus } from "@/enums/mateEnums";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { routerBack } from "@/use/go";

const route = useRoute();
const userStore = useGlobalUser();
const taskStore = useUserTask();
const modalStore = useGlobalModal();
const listRef = ref<ThreadListInstance | null>(null);
const taskScreen = ref(
  (userStore.user.extraConfig?.taskScreen as boolean) ?? true
);
const goBack = () => {
  if (route.name !== "userTask") {
    modalStore.showTaskPageModal = false;
  } else {
    routerBack();
  }
};
// const selectedType = ref<UserTaskType | "all">("all");
const { t } = useI18n();

const filterTabs = [
  { value: undefined, label: t(`userTask.status.all`) },
  {
    value: UserTaskStatus.IN_PROGRESS,
    label: t(`userTask.status.${UserTaskStatus.IN_PROGRESS}`),
  },
  {
    value: UserTaskStatus.COMPLETED,
    label: t(`userTask.status.${UserTaskStatus.COMPLETED}`),
  },
  {
    value: UserTaskStatus.CLAIMED,
    label: t(`userTask.status.${UserTaskStatus.CLAIMED}`),
  },
];

// const taskTypes = [
//   { value: "all", label: "全部" },
//   { value: UserTaskType.DAILY, label: "日常" },
//   { value: UserTaskType.WEEKLY, label: "周任务" },
//   { value: UserTaskType.ACTIVITY, label: "活动" },
//   { value: UserTaskType.MISSION, label: "主线" },
// ];

const onTabChange = (tab?: UserTaskStatus) => {
  taskStore.activeFilter.status = tab;
  onPullRefresh();
};

// const onTypeChange = (type: UserTaskType | "all") => {
//   selectedType.value = type;
//   taskStore.setFilter({
//     type: type === "all" ? undefined : type,
//   });
// };

// 下拉刷新
const onPullRefresh = async () => {
  taskStore.clear();
  listRef.value?.resetScrollLoadingState();
};

// 滚动加载更多
const onScrollLoad = async (): Promise<boolean> => {
  await taskStore.fetchTasks();
  return false;
};

const openTaskDetail = async (id: number) => {
  await taskStore.getTaskDetail(id);
  taskStore.openTaskDetail(id);
};

const claimReward = async (id: number) => {
  try {
    const rewards = await taskStore.claimReward(id);
    modalStore.openReceivedModal(rewards, "paymentReceivedList");
  } catch (error) {
    showFailToast("领取奖励失败，请重试");
    console.error("Claim reward error:", error);
  }
};

// 常驻屏幕切换
const onTaskScreenChange = () => {
  userStore.updateUserExtraConfig({ taskScreen: taskScreen.value });
  modalStore.showTaskPageModal = false;
};

onMounted(() => {
  onPullRefresh();
});
</script>
